import type { ReactNode } from 'react'

import { useAuth } from '@/features/auth/hooks/useAuth'
import NotFoundPage from '@/features/sessions/pages/NotFoundPage'

import { useCanManageComms } from '../hooks/useCanManageComms'

/**
 * Guarda de `/comunicaciones` (spec 2026-10-09-comunicaciones, CU8). Sin el permiso pinta
 * `NotFoundPage` (404 silencioso, como `RequireAdmin`: no revelamos que la sección existe).
 * Mientras arranca la sesión, un loader para evitar el destello del 404.
 */
export function RequireComms({ children }: { children: ReactNode }) {
  const { status } = useAuth()
  const canManage = useCanManageComms()

  if (status === 'idle' || status === 'booting') {
    return <div className="container py-8 text-center text-muted-foreground">…</div>
  }
  if (!canManage) {
    return <NotFoundPage />
  }
  return <>{children}</>
}
